
<template>
    <!-- Crear Tarea -->
        <b-modal
            size="xl"
            ok-only
            
            title="Crear Actividad"
            cancel-title="Cancelar"
            ok-title="Cerrar"
            no-close-on-backdrop
            no-close-on-esc
            class="modal-success"
            v-model="modalCrearTarea"
            @ok="modalCrearTarea = false"
            @cancel="modalCrearTarea = false"
            >
            <b-card>
                <b-row size="sm">
                <b-col sm="1"> 
                    <label >Tarea: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.tarea" :options="lovTarea" size="sm" @change="obtActividad()"></b-form-select>
                </b-col>
                <b-col sm="3"> 
                    <label >Fecha de inicio: </label>
                </b-col>
                <b-col sm="3"> 
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.feinicio" 
                        :default-value="this.datosFormulario.feinicio"
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        >
                    </b-form-datepicker> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Actividad: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.actividad" :options="lovActividad" size="sm" @change="obtResultado()"></b-form-select>    
                </b-col>
                <b-col sm="3"> 
                    <label >Fecha de vencimiento: </label>
                </b-col>
                <b-col sm="3">
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.fevencimiento" 
                        :default-value="datosFormulario.fevencimiento"
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        >
                    </b-form-datepicker> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Asistente: </label>
                </b-col>
                <b-col sm="5"> 
                    <b-form-select v-model="datosFormulario.asistente" :options="lovAsistente" size="sm" ></b-form-select>
                </b-col>
                <b-col sm="3">
                    <label >Fecha de término: </label>
                </b-col>
                <b-col sm="3">
                    <b-form-datepicker 
                        id="example-datepicker" 
                        v-model="datosFormulario.fetermino" 
                        size="sm" 
                        :date-format-options="{ day: '2-digit',  month: '2-digit', year: 'numeric' }"
                        locale="ES"
                        disabled>
                    </b-form-datepicker> 
                    
                </b-col>

            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="1"> 
                    <label >Resultado: </label>
                </b-col>
                <b-col sm="2">
                    <b-form-select  v-model="datosFormulario.resultado" :options="lovResultado" size="sm" disabled></b-form-select>
                </b-col>
                <b-col sm="1"> 
                    <label >Usuario: </label>
                </b-col>
                <b-col sm="2"> 
                    <b-form-input size="sm" type="text" v-model="datosFormulario.usuario" disabled> </b-form-input> 
                </b-col>
                <b-col sm="3"> 
                    <label >Póliza: </label>
                </b-col>
                <b-col sm="3"> 
                    <b-form-input size="sm" type="text" v-model="datosFormulario.poliza" disabled> </b-form-input> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="9"> </b-col>
                <b-col sm="3"> 
                    <b-form-checkbox
                        id="checkbox-1"
                        v-model="datosFormulario.prioridad"
                        name="checkbox-1"
                        value="1"
                        unchecked-value="0"
                        >
                        Prioridad
                    </b-form-checkbox> 
                </b-col>
            </b-row>
            <b-row class="my-1" size="sm">
                <b-col sm="12"> 
                    <b-form-textarea
                        id="textarea"
                        v-model="datosFormulario.comentarios"
                        placeholder="Comentarios..."
                        rows="3"
                        max-rows="3">
                    </b-form-textarea>
                </b-col>    
            </b-row>    
        </b-card>   
            <template #modal-footer>
                <b-col  sm="9" class="float-left" >
                    <b-button  @click="cancelar_tarea" >
                        Cancelar
                    </b-button>
                </b-col>
                    
                <b-col sm="3" class="float-right"   >
                    <!-- <b-button size="md" variant="outline-secondary" @click="reasignar()">
                        Reasignar
                    </b-button> -->
                    
                    <b-button class="float-right el-button" size="sm"  @click="crear_tarea">
                        Aceptar
                    </b-button>
                </b-col>         
            </template>
            
        </b-modal>
  
</template>

<script>
import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiTareas from "@/components/services/apiTareas";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


import XLSX from "xlsx";

export default {
  name: "crearTarea",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  
  props: {
    
    deDonde: String,
    tarea: String,
    actividad: String,
    nroCorrespondencia: Number,
    nroSiniestro: Number,
    nroPoliza: Number,
    ejecutivo: String,
    asistente: String,

  },
  
  components: {
    cSwitch
  },
  data: function() {
    return {

        data: [],
      
        es: es,
        busqueda: "",
        pagina: 1,
        paginaAnterior: 1,
        labelIcon: {
            dataOn: "\u2713",
            dataOff: "\u2715"
        },

      datosFormulario: {
        codtarea:"",
        tarea:"",
        actividad:"",
        asistente:"",
        resultado:"",
        usuario:"",
        feinicio:"",
        fevencimiento:"",
        fetermino:"",
        poliza:"",
        prioridad:"",
        comentarios:"",
        siniestro:""
        
        },

      modalCrearTarea: false,
      
      lovTarea: [],
      lovActividad: [],
      lovAsistente: [],
      lovResultado: [],
      
      datosFormularioEstado: [],
      datosModificacionEstado: [],
      mensajeValidacionCampo: {},

    };
  },
  components:{
    Datepicker,
    Multiselect
  },
  methods: {

    pre_insertar() {
        return apiTareas
            .pre_insertar(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                0,
                0
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
          
                //Bloqueo usuario no valido
                this.datosFormulario.usuario = response.data.args_out.codejecutivo;
                
                this.lovTarea = this.llenaArrayLista(response.data.tareas, 'codigo', 'descripcion', false);
                this.lovAsistente = this.llenaArrayLista(response.data.asistentes, 'codigo', 'descripcion', false);
                // this.datosFormulario.tarea = 14;
                this.datosFormulario.tarea = this.$route.query.tarea;
                this.datosFormulario.poliza = this.$route.query.nroPoliza;
                this.datosFormulario.siniestro = this.$route.query.nroSiniestro;
                this.datosFormulario.asistente = this.$route.query.asistente;
                this.obtActividad(); 
                
                this.datosFormularioEstado = response.data.festado;
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });
    },

    obtActividad(){
        return apiTareas
            .pre_insertar(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.tarea,
                0
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);
                this.lovActividad = this.llenaArrayLista(response.data.actividades, 'codigo', 'descripcion', false);

                var lista_actividad = response.data.actividades;
                for(var i = 0; i < lista_actividad.length; i++){
                    this.datosFormulario.actividad =  lista_actividad[i]["activdefault"];
                    
                }
                if (this.datosFormulario.actividad != ''){
                        this.obtResultado();
                            this.recuperar_tarea();
                    }
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });
    
    },

    obtResultado(){
        return apiTareas
            .pre_insertar(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.tarea,
                this.datosFormulario.actividad,
            )
            .then((response) => {
                response.data = this.keysMinuscula(response.data);

                var lista_data = response.data.res;
                for(var i = 0; i < lista_data.length; i++){
                    
                    this.datosFormulario.feinicio = lista_data[i]["feingreso"];
                    this.datosFormulario.fevencimiento = lista_data[i]["fevencimiento"];
                }

                this.lovResultado = this.llenaArrayLista(response.data.resultados, 'codigo', 'descripcion', false);
                
        })
        .catch((error) => {
          this.crearNotificacion("Error de sistema", error, "error");
        });
    },
    
    crear_tarea() {

        return apiTareas
            .crear_tarea(
                this.$session.get("mail"),
                this.$session.get("usuarioInterno"),
                this.datosFormulario.codtarea,
                this.datosFormulario.tarea, 
                this.datosFormulario.actividad, 
                this.datosFormulario.asistente, 
                this.datosFormulario.feinicio, 
                this.datosFormulario.fevencimiento, 
                this.datosFormulario.fetermino, 
                this.datosFormulario.resultado, 
                this.datosFormulario.poliza, 
                this.datosFormulario.siniestro,
                this.datosFormulario.prioridad, 
                this.datosFormulario.comentarios
            )
            .then((response) => {
                this.datosFormularioEstado = response.data.festado;
                this.crearNotificacion("Crear Actividad","Actividad Creada.","success");
                // this.modalAccionCompletar= false;
                this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'crearTarea', 
                                                                     nroCorrespondencia: '',
                                                                     nroSiniestro: this.datosFormulario.siniestro,
                                                                     nroPoliza: this.datosFormulario.poliza,
                                                                     ejecutivo: this.datosFormulario.ejecutivo,
                                                                     asistente: this.datosFormulario.asistente }});
                
    
                
            })
            .catch((error) => {
            this.crearNotificacion("Error de sistema", error, "error");
            });

    },

    cancelar_tarea(){
        this.$router.push({ path: 'CrearSiniestro', query: { deDonde: 'crearTarea', 
                                                                     nroCorrespondencia: '',
                                                                     nroSiniestro: this.datosFormulario.siniestro,
                                                                     nroPoliza: this.datosFormulario.poliza,
                                                                     ejecutivo: this.datosFormulario.ejecutivo,
                                                                     asistente: this.datosFormulario.asistente }});
    },
    
    llenaArrayLista(data, valor, texto, isDate){
      var arr = new Array();
      for(var i = 0; i < data.length; i++){
          var obj = new Object();
          if (isDate){
            obj.value = this.convierteFecha(data[i][valor]);
            obj.text = this.convierteFecha(data[i][texto]);
          } else {
            obj.value = data[i][valor].toString();
            obj.text = data[i][texto];
          }
          arr.push(obj);
        }
        return arr;
    },

    convierteFecha(fechaEntrada){
        if((fechaEntrada != undefined) && (fechaEntrada.length != 0)){
            var fecha = new Date(fechaEntrada);

            var dia = ("0" + fecha.getUTCDate()).slice(-2);
            var mes = ("0" + (fecha.getUTCMonth() + 1)).slice(-2)
            var año = fecha.getUTCFullYear();

            fecha = dia + '-' + mes + '-' + año;

            return fecha;
        }
        else{
            return fechaEntrada;
        }
    },

    recuperar_tarea(){
        return apiTareas
            .recuperar_tarea(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.datosFormulario.poliza, 
            this.datosFormulario.siniestro,
            this.datosFormulario.tarea, 
            this.datosFormulario.actividad
            )  
            .then(response => {

                response.data = this.keysMinuscula(response.data);
                
                var lista_data = response.data.tarea;

                // console.log(lista_data);

                for(var i = 0; i < lista_data.length; i++){
                    
                    this.datosFormulario.codtarea = lista_data[i]["codtarea"]; 
                    this.datosFormulario.tarea = lista_data[i]["tarea"]; 
                    this.datosFormulario.actividad = lista_data[i]["actividad"];  
                    this.datosFormulario.asistente = lista_data[i]["asistente"];  
                    this.datosFormulario.feinicio = lista_data[i]["feinicio"]; 
                    this.datosFormulario.fevencimiento = lista_data[i]["fevencimiento"]; 
                    this.datosFormulario.fetermino = lista_data[i]["fetermino"]; 
                    this.datosFormulario.resultado = lista_data[i]["resultado"];  
                    this.datosFormulario.poliza = lista_data[i]["poliza"]; 
                    this.datosFormulario.siniestro = lista_data[i]["siniestro"];
                    this.datosFormulario.prioridad = lista_data[i]["prioridad"];
                    this.datosFormulario.comentarios = lista_data[i]["comentario"];
                    
                }
                 
                 
                 
                 
                 
                    this.$Progress.finish();
                })
                .catch(error => {
                    this.mensaje= error;
                    this.variant="warning";
                    this.showAlert = true;
                    this.$Progress.finish();
                });

    },
  },
  
  mounted() {
    this.pagina = Number(this.$route.query.pagina);
    this.pre_insertar();
    this.modalCrearTarea = true;

  },

  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
      
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.label-blanco{
  color: #fff;
}

.col-sm-per{
    position: relative;
    width: 100%;
    padding-right: 5px;
    padding-left: 5px;
    padding-bottom: 2px;
    padding-top: 2px;
}


</style>
